import React, { useState } from "react";
import toast from "react-hot-toast";
import { Container } from "reactstrap";

const Newsletter = () => {
  const [subscribed, setSubscribed] = useState(false);
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Please enter your email");
      return;
    }

    setSubscribed((prev) => !prev);
    toast.success(subscribed ? "Unsubscribed" : "You're on the list!");
  };

  return (
    <section className="bg-white pb-[90px] pt-10">
      <Container>
        <div className="relative grid items-center gap-8 overflow-hidden rounded-[28px] bg-[radial-gradient(circle_at_85%_20%,rgba(255,255,255,0.18),transparent_40%),linear-gradient(135deg,#0e9a7f_0%,#17bf9e_55%,#0a2b1e_140%)] px-6 py-8 shadow-brand md:grid-cols-[1.1fr_0.9fr] md:px-10 md:py-11">
          <div className="pointer-events-none absolute -bottom-[90px] -right-[60px] h-[280px] w-[280px] rounded-full bg-white/10" />

          <div className="relative z-[1]">
            <p className="section-label text-white/80">Stay in the loop</p>
            <h2 className="mb-3 text-white">Study tips and product updates, lightly.</h2>
            <p className="m-0 max-w-[42ch] text-white/80">
              Subscribe for occasional notes on new tools and smarter ways to use
              EzShiksha — no spam, unsubscribe anytime.
            </p>
          </div>

          <form
            className="relative z-[1] flex gap-2.5 rounded-full bg-white/95 p-1.5 shadow-[0_12px_30px_rgba(5,28,20,0.18)] max-lg:flex-col max-lg:rounded-[20px]"
            onSubmit={handleSubmit}
          >
            <label className="sr-only" htmlFor="newsletter-email">
              Email address
            </label>
            <input
              id="newsletter-email"
              type="email"
              placeholder="you@college.edu"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="min-w-0 flex-1 border-0 bg-transparent px-4 py-3 font-display text-[0.95rem] text-brand-forest outline-none"
            />
            <button type="submit" className="btn shrink-0 whitespace-nowrap max-lg:w-full">
              {subscribed ? "Unsubscribe" : "Subscribe"}
            </button>
          </form>
        </div>
      </Container>
    </section>
  );
};

export default Newsletter;
